import React, {Fragment, useContext, useEffect, useState} from 'react';
import Container from 'react-bootstrap/Container';
import {Col, Form, Row} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {fetchToken} from "../../middleware/Firebase.js";
import {Button, Dialog, ListItemButton, MenuItem, Select, Slide, TextField} from "@mui/material";
import {isIpad, isMac, isStandalone} from "../../service/UtilityService.js";
import {ClientJS} from 'clientjs';
import {makeStyles} from '@mui/styles';
import Card from '@mui/material/Card';
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Avatar from "@mui/material/Avatar";
import baseMaleAvatar from "../../../images/male-icon.svg";
import baseFemaleAvatar from "../../../images/female-icon.svg";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import exitIcon from "../../../images/exit-icon.svg";
import {useMediaQuery} from "react-responsive";
import CardContent from "@mui/material/CardContent";
import CurrencyFormat from 'react-currency-format';
import currencyCodes from "currency-codes";
import DialogDoubleAction from "../../components/DialogDoubleAction.js";
import spinner from "../../../images/spinner.svg";
import baseCompanyAvatar from "../../../images/company-avatar.svg";
import {useTranslation} from "react-i18next";
import themeContext from "../../components/ThemeContext.js";
import ErrorPage from "../../pages/ErrorPage.js";
import {NavbarContext} from "../../middleware/NavbarContext.js";
import {SidebarContext} from "../../middleware/SidebarContext.js";
import {
    ExternalPageLayout,
    StyledNoItemsDiv,
    StyledPageCard,
    StyledPageLayout,
    StyledTitlePage
} from "../../styles/DesktopStyles.js";
import {confirmRefund, getAllRefunds, getBankRefByHolder} from "../../service/RefundsService.js";
import {getPeopleImages, getPolicyPeopleData} from "../../service/DashboardService.js";
import {drawerWidth} from "../../components/desktop/DetailBar.js";
import {DetailBarContext} from "../../middleware/DetailBarContext.js";
import {CARD_TYPE} from "../../components/desktop/ListCard.js";
import {REFUND_TYPE} from "../../components/desktop/RefundDetail.js";
import {
    createBankRefByHolder, operationComplete,
    operationCreateOrUpdate,
    patchBankRefByHolder,
    sendBankRefMail
} from "../../service/CommonService.js";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100% !important',
    },
    card: {
        margin: "0 auto !important",
        marginBottom: "18px !important",
        background: `${themeContext.color.white} 0% 0% no-repeat padding-box !important`,
        boxShadow: `2px 3px 10px ${themeContext.color.boxShadow} !important`,
        borderRadius: "10px !important",
        opacity: "1 !important",
        minHeight: "140px !important"
    },
    cardTextMid: {
        color: `${themeContext.color.neutral600} !important`,
        textAlign: 'left !important',
        lineHeight: '1 !important',
        fontWeight: '400 !important',
        fontSize: '12px !important',
        paddingTop: '10px !important',
        paddingBottom: '7px !important',
    },
    personAvatar: {
        width: "30px !important",
        height: "30px !important",
    },
    listItem: {
        width: "100% !important",
        fontSize: "14px !important",
        color: `${themeContext.color.neutral400} !important`,
        paddingTop: '18px !important',
        paddingBottom: '18px !important',
    },
    subtitle: {
        textAlign: "left !important",
        fontSize: "18px !important",
        fontStyle: "normal !important",
        lineHeight: "normal !important",
        fontWeight: "700 !important",
        color: `${themeContext.color.neutral400} !important`,
    },
    CTAButton: {
        fontWeight: '500 !important',
        fontSize: '14px !important',
        fontStyle: 'normal !important',
        lineHeight: 'normal !important',
        color: `${themeContext.color.mainActive} !important`,
        textTransform: 'uppercase !important',
        float: 'left !important',
        marginBottom: '8px !important'
    },
    revisionButton: {
        fontWeight: '500 !important',
        fontSize: '14px !important',
        fontStyle: 'normal !important',
        lineHeight: 'normal !important',
        color: `${themeContext.color.yellow} !important`,
        textTransform: 'uppercase !important',
        float: 'right !important',
        marginTop: '14px !important'
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function Refunds({layout}) {
    const {open} = useContext(SidebarContext);
    const root = 'refunds';
    let defaultValues = {
        accountHolder: "",
        iban: "",
        swift: "",
        currency: "EUR"
    };
    const checkReadUrl = `${process.env.REACT_APP_BASE_URL}/notifications/notify/checkRead`;
    const checkIbanUrl = `${process.env.REACT_APP_BASE_URL}/profile/user/checkIban`;
    const getBankRefsByUserUrl = `${process.env.REACT_APP_BASE_URL}/profile/user/getBankRefsByUser`;
    const getBankRefsByNameUrl = `${process.env.REACT_APP_BASE_URL}/media/refundPremium/getBankRefByName`;
    const getBankRefsByPersonIdUrl = `${process.env.REACT_APP_BASE_URL}/media/refundPremium/getBankRefByPersonId`;
    const checkSwiftUrl = `${process.env.REACT_APP_BASE_URL}/media/refundPremium/checkSwift`;
    const confirmIbanUrl = `${process.env.REACT_APP_BASE_URL}/media/refundPremium/confirmIban`;
    const token = sessionStorage.getItem('token');
    const policyToken = sessionStorage.getItem('policy_token');
    const [isLoadingData, setIsLoadingData] = useState(false);
    const navigate = useNavigate();
    const [openNestedNotSigned, setOpenNestedNotSigned] = useState(0);
    const isDesktop = useMediaQuery({query: '(min-width: 768px)'})
    const [errors, setErrors] = useState({});
    const client = new ClientJS();
    const [bellRinging, setBellRinging] = useState(false);
    const classes = useStyles();
    const [people, setPeople] = useState([]);
    const [getPermission, setGetPermission] = useState(false);
    const [selectedRequestedPremium, setSelectedRequestedPremium] = useState(null);
    const [selectedNotificationId, setSelectedNotificationId] = useState(null);
    const [errorPage, setErrorPage] = useState(false);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [openConfirmIbanDialog, setOpenConfirmIbanDialog] = useState(false);
    const [noRefunds, setNoRefunds] = useState(false);
    const [formValues, setFormValues] = useState(defaultValues)
    const [isLoadingForm, setIsLoadingForm] = useState(false);
    const [selectedPerson, setSelectedPerson] = useState('');
    const [holders, setHolders] = useState([])
    const [initialForm, setInitialForm] = useState(defaultValues);
    const [isLoadingConfirm, setIsLoadingConfirm] = useState(false);
    const {t, i18n} = useTranslation();
    const {toggleNavbar} = useContext(NavbarContext);
    const [disableSwift, setDisableSwift] = useState(false);
    const [activeRefund, setActiveRefund] = useState(null);
    const {updateDataAndType, data} = useContext(DetailBarContext);

    useEffect(() => {
        toggleNavbar(true)
        sessionStorage.setItem('root', '/signing');
        if (navigator.onLine) {
            if (sessionStorage.getItem("notificationId") != null) {
                const url = sessionStorage.getItem("notificationId").replaceAll('"', '')
                navigateToMessageDetails(url);
            }
            handleRinging();
            getRefunds();
        } else {
            //
        }
    }, []);

    useEffect(() => {
        if(activeRefund && !openDetailsDialog && !openConfirmIbanDialog ) {
            setDisableSwift(activeRefund.bank_ref?.iban?.toUpperCase().startsWith('IT'))
            switch(data?.type) {
                case REFUND_TYPE.ADD:
                case REFUND_TYPE.MODIFY:
                    data.type = null;
                    setSelectedPerson(activeRefund.policyholder)
                    setSelectedRequestedPremium(activeRefund.requested)
                    setFormValues({
                        ...formValues,
                        iban: activeRefund.bank_ref.iban || '',
                        currency: activeRefund.bank_ref.currency ? activeRefund.bank_ref.currency : 'EUR',
                        swift: activeRefund.bank_ref.swift || '',
                        accountHolder: activeRefund.bank_ref.account_holder || activeRefund.policyholder.name,
                        id: activeRefund.bank_ref.id || null
                    });
                    setOpenDetailsDialog(true)
                    break;
                case REFUND_TYPE.CONFIRM:
                    data.type = null;
                    setSelectedPerson(activeRefund.policyholder)
                    setSelectedNotificationId(activeRefund.id)
                    setOpenConfirmIbanDialog(true)
                    break;
            }
        }
    }, [activeRefund, data]);

    if (((client.isMobileIOS() || isIpad()) && client.getOSVersion() < "16.4") || (isMac() && client.getOSVersion() < "13") || ((client.isMobileIOS() || isIpad()) && !(client.getOSVersion() < "16.4") && !isStandalone())) {
        //console.log('notification not allowed')
    } else if (!getPermission) {
        requestPermission();
        setGetPermission(true);
    }
    fetchToken();

    function requestPermission() {
        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
            }
        })
    }

    if (((client.isMobileIOS() || isIpad()) && client.getOSVersion() < "16.4") || (isMac() && client.getOSVersion() < "13") || ((client.isMobileIOS() || isIpad()) && !(client.getOSVersion() < "16.4") && !isStandalone())) {
        //console.log('notification not allowed')
    } else {
        const channel = new BroadcastChannel('sw-messages');
        channel.onmessage = (event) => {
            setBellRinging(true)
        };
        channel.onmessageerror = (event) => {
        };
    }

    const navigateToMessageDetails = (url) => {
        return navigate(`/messages/principal/${url}`);
    }

    const handleRinging = () => {
        fetch(checkReadUrl, {
            method: 'GET', headers: {'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json',},
        }).then((response) => {
            return response.json();
        }).then((data) => {
            if (data.toRead) {
                setBellRinging(true);
            } else {
                setBellRinging(false);
            }
        }).catch(() => {
            setErrorPage(true)
        })
    }

    const submitForm = async (event) => {
        event.preventDefault();
        const newErrors = {};
        if (!formValues.iban) {
            newErrors.iban = t('IBAN not valid');
        } else {
            try {
                const response = await checkIban(formValues.iban);
                const data = await response.json();
                if (data.message === "IBAN not valid" || data.message === "IBAN not usable") {
                    newErrors.iban = t('IBAN not valid');
                }
            } catch (e) {
                newErrors.iban = t('IBAN validation error');
            }
        }
        if (!formValues.accountHolder) {
            newErrors.accountHolder = t('Required field');
        }
        if (formValues.currency !== 'EUR' && !formValues.swift) {
            newErrors.swift = t('This field is required for currency not equal to EUR');
        }
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        if (JSON.stringify(formValues) === JSON.stringify(initialForm)) {
            setErrors({})
            setOpenDetailsDialog(false)
            return;
        }
        checkSwift();
    }

    const checkSwift = () => {
        fetch(checkSwiftUrl, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                swiftCode: formValues.swift,
                currency: formValues.currency
            }),
        }).then((response) => {
            return response.json();
        }).then((data) => {
            if (data.ok) {
                setIsLoadingData(true)
                let body = {
                    iban: formValues.iban.toUpperCase().split(" ").join(""),
                    swift: formValues.swift,
                    currency: formValues.currency
                }
                const emailBody = {
                    policyPersonId: selectedPerson.person_id,
                    newIban: formValues.iban.toUpperCase().split(" ").join(""),
                    bankRefDto: {
                        iban: "",
                        swift: formValues.swift,
                        currency: formValues.currency,
                        accountHolder: formValues.accountHolder,
                    }
                }
                if(formValues.id) {
                    patchBankRefByHolder(policyToken, selectedPerson.id, body).then(() => {
                        setIsLoadingData(false)
                        sendBankRefMail(token, emailBody).then(() => {
                            window.location.reload();
                        })
                    }).catch(() => {
                        setIsLoadingData(false)
                        setErrorPage(true)
                    })
                } else {
                    createBankRefByHolder(policyToken, selectedPerson.id, body).then(() => {
                        setIsLoadingData(false)
                        sendBankRefMail(token, emailBody).then(() => {
                            window.location.reload();
                        })
                    }).catch(() => {
                        setIsLoadingData(false)
                        setErrorPage(true)
                    })
                }
            } else {
                const newErrors = {};
                if (data.message.includes('Swift')) {
                    newErrors.swift = t(data.message);
                }
                if (Object.keys(newErrors).length > 0) {
                    setErrors(newErrors);
                }
            }
        }).catch(() => {
            setErrorPage(true)
        })
    }

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        switch (name) {
            case 'accountHolder':
                getBankRefByName(value);
                break;
            case 'iban':
                if (value.toUpperCase().startsWith('IT')) {
                    setDisableSwift(true)
                    setFormValues({
                        ...formValues,
                        [`${name}`]: value,
                        ['swift']: '',
                    });
                } else{
                    setFormValues({
                        ...formValues,
                        [`${name}`]: value,
                    });
                    setDisableSwift(false)
                }
                break;
            case 'currency':
                setFormValues({
                    ...formValues,
                    [`${name}`]: value,
                });
                if (value === 'EUR' && errors.swift) {
                    setErrors({
                        ...errors,
                        ['swift']: null
                    })
                }
                break;
            default:
                setFormValues({
                    ...formValues,
                    [`${name}`]: value,
                });
                break;
        }
    }

    function reload() {
        window.location.reload();
    }

    const handleClick = (index) => {
        if (openNestedNotSigned === index) {
            setOpenNestedNotSigned(-1)
        } else {
            setOpenNestedNotSigned(index)
        }
    }

    const checkIban = (iban) => {
        return fetch(checkIbanUrl, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                iban: iban.toUpperCase().split(" ").join(""),
            }),
        });
    }

    const getAllBankRefs = (selectedPersonId, selectedName) => {
        setIsLoadingForm(true)
        fetch(getBankRefsByUserUrl, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        }).then((response) => {
            return response.json();
        }).then((data) => {
            setHolders(data)
            getBankRefsByPersonId(selectedPersonId, selectedName)
        }).catch(() => {
            setErrorPage(true)
        })
    }

    const getBankRefByName = (name) => {
        fetch(getBankRefsByNameUrl, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: name,
            }),
        }).then((response) => {
            return response.json();
        }).then((data) => {
            setFormValues({
                ...formValues,
                accountHolder: name,
                iban: data.iban || '',
                currency: data.currency || 'EUR',
                swift: data.swift || ''
            });
            setDisableSwift(data.iban?.toUpperCase().startsWith('IT'))
            if (data.iban) {
                setErrors({
                    ...errors,
                    ['iban']: null
                })
            }
            if (data.swift) {
                setErrors({
                    ...errors,
                    ['swift']: null
                })
            }
        }).catch(() => {
            setErrorPage(true)
        })
    }

    const getRefunds = () => {
        setIsLoadingData(true)
        getPolicyPeopleData(policyToken).then(async (res) => {
            const data = res.data;
            const ids = data.map((item) => ({id: item.id, personId: item.person_id}));
            getPeopleImagesData(ids, data);
        }).catch(() => {
            setErrorPage(true)
        })
    }

    const getPeopleImagesData = (ids, data) => {
        getPeopleImages(token, ids).then((imageData) => {
            setPeople([])
            data.map((item, index) => {
                const imageInfo = imageData.find(image => image.id === item.id);
                if (imageInfo) {
                    item.image = imageInfo.image !== "" ? imageInfo.image : null;
                    item.status = imageInfo.status;
                }
                if (item.status !== -1) {
                    getBankRefByHolder(policyToken, item.id).then((response) => {
                        response.name = item.name;
                        response.personId = item.person_id;
                        response.holderId = item.id;
                        setHolders((current) => [...current, response])
                    }).catch(() => {
                        setErrorPage(true)
                    })
                    getAllRefunds(policyToken).then((data) => {
                        const refunds = data.data;
                        if (data.total === 0) setNoRefunds(true);
                        else {
                            let tempRefunds = refunds.filter(refund => refund.policyholder.id === item.id);
                            if (tempRefunds.length > 0) {
                                item.refund = tempRefunds;
                                setPeople(current => [...current, item])
                            }
                        }
                    }).then(() => {
                        if(index === data.length-1) {
                            setIsLoadingData(false)
                        }
                    }).catch(() => {
                        setErrorPage(true)
                    })
                }
            })
        }).catch(() => {
            setErrorPage(true)
        })
    }

    const getBankRefsByPersonId = (personId, personName) => {
        setIsLoadingForm(true)
        fetch(`${getBankRefsByPersonIdUrl}/${personId}`, {
            method: 'GET', headers: {'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json',},
        }).then((response) => {
            return response.json();
        }).then((data) => {
            setDisableSwift(data.iban?.toUpperCase().startsWith('IT'))
            setFormValues({
                ...formValues,
                iban: data.iban || '',
                currency: data.currency ? data.currency : 'EUR',
                swift: data.swift || '',
                accountHolder: data.accountHolder || personName
            });
            setIsLoadingForm(false)
        }).catch(() => {
            setErrorPage(true)
        })
    }

    function confirmIban() {
        setIsLoadingConfirm(true)
        confirmRefund(policyToken, selectedNotificationId).then(() => {
            operationCreateOrUpdate(token, 'IBAN-CONFIRM', selectedNotificationId).then(() => {
                operationComplete(token, 'IBAN-CONFIRM', selectedNotificationId).then(() => {
                    setIsLoadingConfirm(false)
                    setOpenConfirmIbanDialog(false)
                    updateDataAndType(null, null);
                    setActiveRefund(null);
                    getRefunds();
                }).catch(() => {
                    setIsLoadingConfirm(false)
                    setOpenConfirmIbanDialog(false)
                    setErrorPage(true)
                });
            }).catch(() => {
                setIsLoadingConfirm(false)
                setOpenConfirmIbanDialog(false)
                setErrorPage(true)
            });
        }).catch(() => {
            setIsLoadingConfirm(false)
            setOpenConfirmIbanDialog(false)
            setErrorPage(true)
        });
    }

    function handleOnClick(refund) {
        if(refund.id === activeRefund?.id) {
            updateDataAndType(null, null);
            setActiveRefund(null);
        } else {
            updateDataAndType({data: refund, type: null}, CARD_TYPE.REFUND);
            setActiveRefund(refund);
        }
    }

    return (
        <ExternalPageLayout open={open} style={{marginRight: activeRefund ? `calc(${drawerWidth})` : 0,}} >
            <StyledPageCard>
                {
                    errorPage ?
                        <ErrorPage/> :
                        <StyledPageLayout className="w-100 px-4" style={{background: themeContext.color.neutral10, paddingBottom: 24}}>
                            <StyledTitlePage>
                                <Col className="col-2 float-left"></Col>
                                <Col className="col-8">
                                    <span className="header-title ellipsis-1-v2">{t('refunds.title')}</span>
                                </Col>
                                <Col className="col float-right"></Col>
                            </StyledTitlePage>
                            <Row className="mt-2">
                                <Col className="col-list">
                                    {isLoadingData &&
                                        <Row style={{'height': '85vh'}} className="background-loading-spinner"></Row>
                                    }
                                </Col>
                                {!isLoadingData && noRefunds &&
                                    <StyledNoItemsDiv>
                                        <span className={'d-flex align-items-center font-weight-bold font-italic'}
                                              style={{color: themeContext.color.neutral400}}>{t('refunds.no-refunds')}</span>
                                    </StyledNoItemsDiv>
                                }
                                {!isLoadingData && !noRefunds &&
                                    <List
                                        component="nav"
                                        aria-labelledby="nested-list-subheader"
                                        className={classes.root}>
                                        {people.map((value, index) => (
                                            <Fragment key={index}>
                                                <ListItemButton onClick={() => handleClick(index)}
                                                                className={classes.listItem}>
                                                    <ListItemIcon>
                                                        {value.image === null && value.gender === 'M' &&
                                                            <Avatar className={classes.personAvatar}
                                                                    src={baseMaleAvatar}
                                                                    alt="avatar-image"/>}
                                                        {value.image === null && value.gender === 'F' &&
                                                            <Avatar className={classes.personAvatar}
                                                                    src={baseFemaleAvatar}
                                                                    alt="avatar-image"/>}
                                                        {value.image === null && value.gender === 'C' &&
                                                            <Avatar className={classes.personAvatar}
                                                                    src={baseCompanyAvatar}
                                                                    alt="avatar-image"/>}
                                                        {value.image === null && value.gender === null &&
                                                            <Avatar className={classes.personAvatar}
                                                                    src={baseMaleAvatar}
                                                                    alt="avatar-image"/>}
                                                        {value.image &&
                                                            <Avatar className={classes.personAvatar}
                                                                    src={value.image}
                                                                    alt="avatar-image"/>}
                                                    </ListItemIcon>
                                                    {((value.first_name === null || value.first_name === "") && (value.last_name === null || value.last_name === "")) ?
                                                        <ListItemText className="list-label"
                                                                      secondary={value.name.toLowerCase()}
                                                                      style={{
                                                                          textTransform: 'capitalize',
                                                                          color: themeContext.color.neutral600
                                                                      }}/> :
                                                        <ListItemText className="list-label"
                                                                      secondary={`${value.first_name.toLowerCase()} ${value.last_name.toLowerCase()}`}
                                                                      style={{
                                                                          textTransform: 'capitalize',
                                                                          color: themeContext.color.neutral600
                                                                      }}/>}
                                                    <span style={{
                                                        textAlign: 'right',
                                                        fontSize: '12px',
                                                        fontWeight: '700'
                                                    }}></span>
                                                    {openNestedNotSigned === index ? <ExpandMore/> : <ExpandLess/>}
                                                </ListItemButton>
                                                <Collapse in={openNestedNotSigned === index} timeout="auto"
                                                          unmountOnExit>
                                                    <div>
                                                        <Row>
                                                            <List component="div" className="col div-under-list">
                                                                {value.refund.map((refund) => {
                                                                    return (
                                                                        <Fragment key={refund.id}>
                                                                            <Card className={classes.card}
                                                                                  style={activeRefund?.id === refund.id ? {outline: `${themeContext.spacing.borders.border2} ${themeContext.color.main}`} : {}}
                                                                                  onClick={() => {handleOnClick(refund)}}
                                                                                  key={refund.id}>
                                                                                <CardContent
                                                                                    style={{'paddingBottom': '12px'}}>
                                                                                    <Row>
                                                                                        <Col>
                                                                                            <h6 className={"card-text-content"}
                                                                                                style={{
                                                                                                    color: themeContext.color.main,
                                                                                                    lineHeight: '1',
                                                                                                    fontSize: '19px'
                                                                                                }}>
                                                                                                <span
                                                                                                    style={{
                                                                                                        fontSize: '29px'
                                                                                                    }}>
                                                                                                        <CurrencyFormat
                                                                                                            displayType={'text'}
                                                                                                            value={refund.requested.replace('-','')}
                                                                                                            thousandSeparator={'.'}
                                                                                                            decimalSeparator={','}
                                                                                                        />€ <span
                                                                                                    style={{fontSize: '19px'}}>{t(`${root}.price-text`)}</span>
                                                                                                </span>
                                                                                            </h6>
                                                                                        </Col>
                                                                                        {refund.stage !== null &&
                                                                                            <Col className="float-right">
                                                                                                <span className={classes.revisionButton}>
                                                                                                    {t(`${root}.revision`)}
                                                                                                </span>
                                                                                            </Col>
                                                                                        }
                                                                                    </Row>
                                                                                    <Row>
                                                                                        <Col className="div-masked">
                                                                                            <Row>
                                                                                                <Col>
                                                                                                    <h6 className={"card-text-content ellipsis-1-v2"}
                                                                                                        style={refund.bank_ref.account_holder ? {} : {color: themeContext.color.red}}>
                                                                                                        {t('refunds.holder')}:
                                                                                                        <span
                                                                                                            className={refund.bank_ref.account_holder ? "font-weight-bold black" : "font-weight-bold"}>
                                                                                                    {refund.bank_ref.account_holder ? ' ' + refund.bank_ref.account_holder : ' - '}
                                                                                        </span>
                                                                                                    </h6>
                                                                                                </Col>
                                                                                            </Row>
                                                                                            <Row>
                                                                                                <Col>
                                                                                                    <h6 className={"card-text-content ellipsis-1-v2"}
                                                                                                        style={refund.bank_ref.iban ? {} : {color: themeContext.color.red}}>
                                                                                                        {t('refunds.iban')}:
                                                                                                        <span
                                                                                                            className={refund.bank_ref.iban ? "font-weight-bold black" : "font-weight-bold"}>
                                                                                                      {refund.bank_ref.iban ? ' ' + refund.bank_ref.iban : ' - '}
                                                                                          </span>
                                                                                                    </h6>
                                                                                                </Col>
                                                                                            </Row>
                                                                                            <Row>
                                                                                                <Col>
                                                                                                    <h6 className={"card-text-content ellipsis-1-v2"}
                                                                                                        style={(refund.bank_ref.swift || refund.bank_ref.currency === 'EUR') ? {} : {color: themeContext.color.red}}>
                                                                                                        {t('refunds.swift')}:
                                                                                                        <span
                                                                                                            className={refund.bank_ref.swift ? "font-weight-bold black" : "font-weight-bold"}>
                                                                                                      {refund.bank_ref.swift ? ' ' + refund.bank_ref.swift : ' - '}
                                                                                         </span>
                                                                                                    </h6>
                                                                                                </Col>
                                                                                            </Row>
                                                                                            <Row>
                                                                                                <Col>
                                                                                                    <h6 className={"card-text-content ellipsis-1-v2"}
                                                                                                        style={refund.bank_ref.currency ? {} : {color: themeContext.color.red}}>
                                                                                                        {t('refunds.currency')}:
                                                                                                        <span
                                                                                                            className={refund.bank_ref.currency  ? "font-weight-bold black" : "font-weight-bold"}>
                                                                                                    {refund.bank_ref.currency ? ' ' + refund.bank_ref.currency : ' - '}
                                                                                         </span>
                                                                                                    </h6>
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </CardContent>
                                                                            </Card>
                                                                        </Fragment>
                                                                    )
                                                                })
                                                                }
                                                            </List>
                                                        </Row>
                                                    </div>
                                                </Collapse>
                                            </Fragment>))
                                        }
                                    </List>
                                }
                            </Row>
                            <Dialog
                                onClose={() => {
                                    setFormValues({})
                                    setErrors({})
                                    setOpenDetailsDialog(false)
                                    setDisableSwift(false)
                                }}
                                fullScreen={!isDesktop}
                                fullWidth={isDesktop}
                                maxWidth={'sm'}
                                PaperProps={{
                                    style: {
                                        bottom: isDesktop ? '5%' : '0',
                                        color: themeContext.color.neutral600,
                                        borderTopLeftRadius: '20px',
                                        borderTopRightRadius: '20px',
                                        borderRadius: isDesktop ? '20px' : 'none',
                                        height: isDesktop ? '90%' : '100%',
                                        marginTop: '10%'
                                    }
                                }}
                                open={openDetailsDialog}
                                TransitionComponent={Transition}
                                aria-labelledby="alert-dialog-slide-title"
                                aria-describedby="alert-dialog-slide-description">
                                <DialogTitle id="alert-dialog-slide-title"
                                             className="dialog-title dialog-title-div"
                                             style={{textAlign: 'center'}}>
                                    <Row style={{justifyContent: 'end'}}>
                                        <img src={exitIcon} className="exit-button" alt="close"
                                             onClick={() => {
                                                 setFormValues({})
                                                 setErrors({})
                                                 setOpenDetailsDialog(false)
                                             }} style={{float: 'inline-end'}}/>
                                    </Row>
                                    <Row style={{marginTop: '-12px'}}>
                                        <Col className="col">
                                            <h6 className="dialog-form-title-1 float-left">{t(`${root}.dialog-title`)}</h6>
                                        </Col>
                                    </Row>
                                </DialogTitle>
                                <DialogContent className="no-scrollbar">
                                    <Container className="dialog-main-container">
                                        <Row>
                                            <Col>
                                                <h6 className="dialog-form-title-2 float-left">
                                                    {t(`desktop.refunds.description`)}
                                                </h6>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <h6 className="dialog-form-subtitle" style={{fontSize: 18}}>
                                                    <CurrencyFormat
                                                        displayType={'text'}
                                                        value={selectedRequestedPremium?.replace('-','')}
                                                        thousandSeparator={'.'}
                                                        decimalSeparator={','}
                                                    /> €
                                                </h6>
                                            </Col>
                                        </Row>
                                        <Row style={{marginTop: '56px'}}>
                                            <Col>
                                                <h6 className="dialog-form-subtitle">{t(`${root}.dialog-subtitle`)}</h6>
                                            </Col>
                                        </Row>
                                        {
                                            isLoadingForm &&
                                            <Row style={{'height': '200px'}}
                                                 className="background-loading-spinner">
                                            </Row>
                                        }
                                        {
                                            !isLoadingForm &&
                                            <Form onSubmit={submitForm} style={{marginBottom: '60px'}}>
                                                <Row>
                                                    <Col>
                                                        <Row className="mt-1">
                                                            <Col>
                                                                <h6 className="dialog-parameter mt-4 text-capitalize">
                                                                    {t(`${root}.holder`)}
                                                                </h6>
                                                            </Col>
                                                        </Row>
                                                        <Select
                                                            variant={'outlined'}
                                                            labelId="accountHolder-label"
                                                            id="accountHolder"
                                                            name="accountHolder"
                                                            value={formValues.accountHolder}
                                                            onChange={handleInputChange}
                                                            fullWidth
                                                            required
                                                            style={{
                                                                'backgroundColor': themeContext.color.white,
                                                                'textAlign': 'left'
                                                            }}
                                                            SelectDisplayProps={{
                                                                style: {
                                                                    'textAlign': 'left',
                                                                    'borderRadius': '4px',
                                                                    'color': themeContext.color.neutral600,
                                                                    'width': '100%',
                                                                }
                                                            }}>
                                                            {
                                                                holders.map((value, index) => (
                                                                    <MenuItem key={index + 1}
                                                                              value={value.name}>
                                                                        {value.name}
                                                                    </MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                        <Row className="mt-1">
                                                            <Col>
                                                                <h6 className="dialog-parameter mt-4 text-capitalize">
                                                                    {t(`${root}.iban`)}
                                                                </h6>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <TextField
                                                                    error={!!errors.iban}
                                                                    helperText={errors.iban}
                                                                    required
                                                                    onChange={handleInputChange}
                                                                    id={`iban`}
                                                                    name={`iban`}
                                                                    value={formValues.iban}
                                                                    fullWidth
                                                                    placeholder=""
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    InputProps={{
                                                                        inputProps: {min: 0},
                                                                        style: {
                                                                            'borderRadius': '4px',
                                                                            'color': themeContext.color.neutral600
                                                                        }
                                                                    }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                        {
                                                            !disableSwift &&
                                                            <>
                                                                <Row className="mt-1">
                                                                    <Col>
                                                                        <h6 className="dialog-parameter mt-4 text-capitalize">
                                                                            {t(`${root}.swift`)}
                                                                        </h6>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>
                                                                        <TextField
                                                                            onChange={handleInputChange}
                                                                            id={`swift`}
                                                                            autoComplete={'off'}
                                                                            name={`swift`}
                                                                            fullWidth
                                                                            placeholder=""
                                                                            variant="outlined"
                                                                            value={formValues.swift}
                                                                            color="primary"
                                                                            error={!!errors.swift}
                                                                            helperText={errors.swift}
                                                                            InputProps={{
                                                                                inputProps: {min: 0},
                                                                                style: {
                                                                                    'borderRadius': '4px',
                                                                                    'color': themeContext.color.neutral600
                                                                                }
                                                                            }}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        }
                                                        <Row className="mt-1">
                                                            <Col>
                                                                <h6 className="dialog-parameter mt-4 text-capitalize">
                                                                    {t(`${root}.currency`)}
                                                                </h6>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Select
                                                                    id={`currency`}
                                                                    name={'currency'}
                                                                    value={formValues.currency}
                                                                    variant={'outlined'}
                                                                    onChange={handleInputChange}
                                                                    fullWidth
                                                                    style={{
                                                                        'backgroundColor': themeContext.color.white,
                                                                        'textAlign': 'left'
                                                                    }}
                                                                    SelectDisplayProps={{
                                                                        style: {
                                                                            'textAlign': 'left',
                                                                            'borderRadius': '4px',
                                                                            'color': themeContext.color.neutral600,
                                                                            'width': '100%',
                                                                        }
                                                                    }}
                                                                >
                                                                    {
                                                                        currencyCodes.data.map((currency, index) => (
                                                                            <MenuItem key={index}
                                                                                      value={currency.code}>
                                                                                {currency.code} - {t(currency.currency)}
                                                                            </MenuItem>
                                                                        ))
                                                                    }
                                                                </Select>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                                <Container className="position-absolute"
                                                           style={
                                                               isDesktop ? {
                                                                   background: 'transparent',
                                                                   opacity: '1',
                                                                   paddingBottom: "20px",
                                                                   left: 0,
                                                                   bottom: 0,
                                                                   right: 0
                                                               } : {
                                                                   background: 'transparent',
                                                                   opacity: '1',
                                                                   paddingBottom: "68px",
                                                                   left: 0,
                                                                   bottom: 0,
                                                                   right: 0
                                                               }
                                                           }>
                                                    <Row style={{textAlign: 'center'}}>
                                                        <Col>
                                                            <Button
                                                                className={"close-button"}
                                                                variant="outlined"
                                                                size="large"
                                                                style={{
                                                                    color: themeContext.color.white,
                                                                    width: '288px',
                                                                    textTransform: 'none'
                                                                }}
                                                                type="submit"
                                                            >{t(`${root}.save`)}</Button>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Form>
                                        }
                                    </Container>
                                </DialogContent>
                            </Dialog>
                            <DialogDoubleAction
                                open={openConfirmIbanDialog}
                                handleClose={() => setOpenConfirmIbanDialog(false)}
                                title={t('refunds.dialog-confirm-iban-title')}
                                description={t('refunds.dialog-confirm-iban-description')}
                                buttonYesText={isLoadingConfirm ?
                                    <img src={spinner} className="spinner-img"
                                         alt="spinner"/> : t('dialog.button-confirm')}
                                handleYes={() => {
                                    confirmIban();
                                }}
                                buttonNoText={t('dialog.button-cancel')}
                                handleNo={() => setOpenConfirmIbanDialog(false)}
                            ></DialogDoubleAction>
                        </StyledPageLayout>
                }
            </StyledPageCard>
        </ExternalPageLayout>
    )
}
